export const EVENT_FORTNITE_ENTER_GAME = "EVENT_FORTNITE_ENTER_GAME";
export const EVENT_FORTNITE_EXIT_GAME = "EVENT_FORTNITE_EXIT_GAME";
export const EVENT_FORTNITE_MATCH_LIVE = "EVENT_FORTNITE_MATCH_LIVE";
export const EVENT_FORTNITE_ITEM_SHARE = "EVENT_FORTNITE_ITEM_SHARE";
